import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, FormGroup, Spinner } from "reactstrap";
import { Block, BlockContent, BlockHead, BlockTitle, Button, Icon, PreviewCard } from "../../components/Component";
import LogoDark from "../../images/logo-dark.png";
import Logo from "../../images/logo.png";
import Head from "../../layout/head/Head";
import PageContainer from "../../layout/page-container/PageContainer";
import AuthFooter from "./AuthFooter";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "", deviceType: "WEB" });

  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);

  const login = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, obj, {
        "Content-Type": "application/json",
        Accept: "application/json",
      });
      const formData = await response.data;
      localStorage.setItem("accessToken", JSON.stringify(formData.token));
      localStorage.setItem("userInfo", JSON.stringify(formData));
      toast.success("User login successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
      if (formData?.loginCount <= 1) {
        window.location.href = "/auth-set";
      } else {
        setTimeout(() => {
          window.history.pushState(
            `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`,
            "auth-login",
            `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`
          );
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      const failedCount = error?.response?.data?.data?.failedCount;
      if (error?.response?.data?.status === 401) {
        toast.error(`Incorrect Email or Password Combination, ${5 - failedCount} tries remaining`, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setLoading(false);
    }
  };

  const onFormSubmit = (formData) => {
    setLoading(true);
    const data = {
      email: formData.email,
      password: formData.password,
      platformType: "ADMIN",
      platform: "TREASURY",
    };
    login(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h4">Sign-In</BlockTitle>
              </BlockContent>
            </BlockHead>
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="email"
                    onChange={handleChange}
                    ref={register({ required: "This field is required" })}
                    // defaultValue="info@softnio.com"
                    placeholder="Enter your email"
                    className="form-control-lg form-control"
                  />
                  {errors.name && <span className="invalid">{errors.name.message}</span>}
                </div>
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    onChange={handleChange}
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your Password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                </div>
              </FormGroup>
              <FormGroup>
                <Button size="lg" className="btn-block" type="submit" color="primary">
                  {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
                </Button>
              </FormGroup>
            </Form>
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default Login;
